import { del, extractErrorMessage, get, patch } from "src/helpers/api_helper"
import { IConfig, IReportedMessage, IUser, IUsersIndicators, IUserDetail, ResponsePagination, ResponseRequest } from "./types"

export const getUsers = async (config: IConfig, filterUsersToValidate: boolean|null|'all'): Promise<ResponseRequest<ResponsePagination<IUser>>> => {
    try {
        let params: any = { ...config, user_type: '10' }
        if (filterUsersToValidate !== 'all') {
            params.is_verified_by_admin = (filterUsersToValidate == null) ? 'null' : filterUsersToValidate
        }
        const response = await get<ResponsePagination<IUser>>('/users', { params })
        if (response.code === 200) {
            return { result: "ok", data: response.data! }
        } else { 
            return { result: "error", message: response.message } 
        }
    } catch (error) {
        const message = extractErrorMessage(error)
        return { result: "error", message }
    }
}

export const updateUser = async ( id: string, data: Partial<IUser> ): Promise<ResponseRequest<IUser>> => {
    try {
        const response = await patch<IUser>(`/users/${id}`, data)
        if (response.code === 200) {
            return { result: "ok", data: response.data! }
        } else { 
            return { result: "error", message: response.message } 
        }
    } catch (error) {
        const message = extractErrorMessage(error)
        return { result: "error", message }
    }
}

export const updateUserVerifiedByAdmin = async ( id: string, isVerifiedByAdmin: boolean | null ): Promise<ResponseRequest<IUser>> => {
    try {
        const response = await patch<IUser>(`/users/${id}`, { isVerifiedByAdmin: isVerifiedByAdmin == null ?  'null' : isVerifiedByAdmin.toString() })
        if (response.code === 200) {
            return { result: "ok", data: response.data! }
        } else { 
            return { result: "error", message: response.message } 
        }
    } catch (error) {
        const message = extractErrorMessage(error)
        return { result: "error", message }
    }
}

export const deleteUser = async ( id: string ): Promise<ResponseRequest<IUser>> => {
    try {
        const response = await del<IUser>(`/users/${id}`)
        if (response.code === 200) {
            return { result: "ok", data: response.data! }
        } else { 
            return { result: "error", message: response.message } 
        }
    } catch (error) {
        const message = extractErrorMessage(error)
        return { result: "error", message }
    }
}

export const getUserDetails = async (id: string): Promise<ResponseRequest<IUserDetail>> => {
    try {
        const response = await get<IUserDetail>('/users/'+id)
        if (response.code === 200) {
            return { result: "ok", data: response.data! }
        } else { 
            return { result: "error", message: response.message } 
        }
    } catch (error) {
        const message = extractErrorMessage(error)
        return { result: "error", message }
    }
}

export const getReportedMessages = async (config: IConfig): Promise<ResponseRequest<ResponsePagination<IReportedMessage>>> => {
    try {
        const response = await get<ResponsePagination<IReportedMessage>>('/users/reported', { params: {...config, user_type: '10'} })
        if (response.code === 200) {
            return { result: "ok", data: response.data! }
        } else { 
            return { result: "error", message: response.message } 
        }
    } catch (error) {
        const message = extractErrorMessage(error)
        return { result: "error", message }
    }
}

export const fetchOccupations = async (): Promise<ResponseRequest<{id: string, text: string}[]>> => {
    try {
        const response = await get<{id: string, text: string}[]>('/occupations/list')
        if (response.code === 200) {
            return { result: "ok", data: response.data! }
        } else { 
            return { result: "error", message: response.message } 
        }
    } catch (error) {
        const message = extractErrorMessage(error)
        return { result: "error", message }
    }
}

export const fetchUsersIndicators = async (): Promise<ResponseRequest<IUsersIndicators>> => {
    try {
        const response = await get<IUsersIndicators>('/user-indicators')
        if (response.code === 200) {
            return { result: "ok", data: response.data! }
        } else { 
            return { result: "error", message: response.message } 
        }
    } catch (error) {
        const message = extractErrorMessage(error)
        return { result: "error", message }
    }
}

export const deleteUsersInBulk = async ( ids: string[] ): Promise<ResponseRequest<IUser[]>> => {
    try {
        const response = await del<IUser[]>(`/users`, { data: { ids } })
        if (response.code === 200) {
            return { result: "ok", data: response.data!, message: response.message || 'Users deleted successfully' }
        } else { 
            return { result: "error", message: response.message } 
        }
    } catch (error) {
        const message = extractErrorMessage(error)
        return { result: "error", message }
    }
}